<!-- ✅ Sidebar visible uniquement sur desktop -->
<div
  [ngClass]="
    isDarkMode()
      ? (isSwap
          ? 'bg-[#1e1e2f]/70 shadow-xl ring-1 ring-purple-800/10 border-l-4 border-purple-500/50 text-white'
          : 'bg-[#1e1e2f]/70 shadow-xl ring-1 ring-blue-800/10 border-l-4 border-blue-500/50 text-white')
      : (isSwap
          ? 'bg-gradient-to-b from-purple-50 to-indigo-50 text-gray-800 shadow-[0_6px_24px_rgba(123,97,255,0.06)] border-l-4 border-purple-300/50'
          : 'bg-gradient-to-b from-blue-50 to-indigo-50 text-gray-800 shadow-[0_6px_24px_rgba(31,78,255,0.06)] border-l-4 border-blue-300/50')
  "
  class="hidden md:flex fixed left-6 top-6 flex-col items-start w-[248px] px-4 py-5 gap-4 z-50 rounded-2xl backdrop-blur-md"
  [ngStyle]="{ 'backdrop-filter': isDarkMode() ? 'blur(12px)' : 'none' }"
>

  <!-- 📂 Navigation principale -->
  <div class="flex flex-col gap-1.5 w-full">
    <!-- 🔁 Swap -->
    <a routerLink="/" class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5">
      <svg class="w-4 h-4 opacity-80 group-hover:opacity-100 transition-opacity"
           [ngClass]="invBridgeLogo" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="1.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 7h16M8 3l-4 4 4 4M20 17H4m12 4 4-4-4-4"/>
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'SWAP' | translate }}
      </span>
    </a>
    <!-- 🔔 Alertes (masqué pour l’instant) -->
    <a
      *ngIf="!isAlertsRoute && false"
      routerLink="/alerts"
      class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5"
    >
      <svg class="w-4 h-4 group-hover:drop-shadow-md" [ngClass]="invBridgeLogo" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10 21h4a2 2 0 0 0 2-2v-1H8v1a2 2 0 0 0 2 2z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2v1h16v-1z" />
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'SET_ALERTS' | translate }}
      </span>
    </a>

    <!-- 🌉 Bridge -->
    <a [routerLink]="['/bridge']" class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5">
      <svg [ngClass]="invBridgeLogo" class="w-4 h-4 opacity-90 group-hover:opacity-100 transition-opacity"
           viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <!-- Tablier -->
        <path d="M4 6h16" stroke-width="1.4" stroke-linecap="round"/>
        <!-- Colonnes -->
        <path d="M6 6v12M18 6v12" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <!-- Bases -->
        <path d="M5 20h2M17 20h2" stroke-width="1.2" stroke-linecap="round"/>
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'BRIDGE' | translate }}
      </span>
    </a>
        <!-- 📰 Blog -->
<a
  [routerLink]="['/', selectedLanguage, 'blog']"
  class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5"
>
  <svg class="w-4 h-4 opacity-80 group-hover:opacity-100 transition-opacity"
       [ngClass]="invBridgeLogo" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25">
    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 10h16M4 14h10M4 18h7"/>
  </svg>
  <span
    class="text-sm font-medium leading-tight"
    [ngClass]="isDarkMode() ? (isSwap ? 'text-purple-400' : 'text-blue-400')
                             : (isSwap ? 'text-purple-600' : 'text-blue-600')">
    {{ 'BLOG_NAV' | translate }}
  </span>
</a>
    <!-- ℹ️ À propos -->
    <a routerLink="/a-propos" class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5">
      <svg class="w-4 h-4 opacity-80 group-hover:opacity-100 transition-opacity"
           [ngClass]="invBridgeLogo" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="1.25">
        <circle cx="12" cy="12" r="9" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 10v6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 7h.01" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'ABOUT' | translate }}
      </span>
    </a>

    <!-- ⚖️ Disclaimer -->
    <a routerLink="/disclaimer" class="group flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-all hover:bg-white/5">
      <svg class="w-4 h-4 opacity-80 group-hover:opacity-100 transition-opacity"
           [ngClass]="invBridgeLogo" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="1.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9z"/>
        <path stroke-linecap="round" stroke-linejoin="round" d="M14 2v7h7"/>
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 13h6M9 17h6M9 9h2"/>
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'DISCLAIMER_NAV' | translate }}
      </span>
    </a>
  </div>

  <!-- ⚙️ Paramètres -->
  <div class="w-full pt-1 border-t border-b  pb-2 " [ngClass]="isDarkMode() ? 'border-white/10' : 'border-gray-300/70'">
    <a (click)="toggleSettings()" class="cursor-pointer flex items-center gap-2 px-2.5 py-1.5 rounded-lg hover:bg-white/5 transition-all mt-1.5">
      <svg class="w-4 h-4 opacity-80 group-hover:opacity-100 transition-opacity"
           [ngClass]="invBridgeLogo" fill="none" viewBox="0 0 24 24"
           stroke="currentColor" stroke-width="1.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"/>
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.4 15.5l1.1 1.9-1.6 1.6-1.9-1.1a7.9 7.9 0 0 1-3 .7l-.5 2.1h-2l-.5-2.1a7.9 7.9 0 0 1-3-.7l-1.9 1.1-1.6-1.6 1.1-1.9a7.9 7.9 0 0 1-.7-3l-2.1-.5v-2l2.1-.5a7.9 7.9 0 0 1 .7-3L3 5.6 4.6 4l1.9 1.1a7.9 7.9 0 0 1 3-.7L10 2.3h2l.5 2.1a7.9 7.9 0 0 1 3 .7L17.4 4 19 5.6l-1.1 1.9c.33.94.57 1.95.7 3l2.1.5v2l-2.1.5c-.13 1.05-.37 2.06-.7 3z"/>
      </svg>
      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'SETTINGS' | translate }}
      </span>
    </a>

    <!-- Sélecteurs langue/devise -->
    <div *ngIf="settingsOpen" class="mt-2.5 flex flex-col gap-2.5 px-1.5 ml-4">
  <div>
    <label class="block mb-1 text-xs font-medium leading-tight"
           [ngClass]="isDarkMode() ? (isSwap ? 'text-purple-400' : 'text-blue-400') : (isSwap ? 'text-purple-600' : 'text-blue-600')">
      {{ 'LANGUAGE' | translate }}
    </label>
    <select
      [(ngModel)]="selectedLanguage"
      (change)="changeLanguage(selectedLanguage)"
      class="w-[90%] px-2 py-1 rounded-lg text-xs shadow-inner focus:outline-none transition border  focus:ring-0 focus:border-purple-500"
      [ngClass]="
        isDarkMode()
          ? 'bg-gray-800 text-white ' + (isSwap ? 'border-purple-700'
                                                : 'border-blue-700')
          : 'bg-white text-black ' + (isSwap ? 'border-purple-400'
                                            : 'border-blue-400')
      "
    >
      <option *ngFor="let lang of languages" [value]="lang.code">{{ lang.label }}</option>
    </select>
  </div>

  <div>
    <label class="block mb-1 text-xs font-medium leading-tight"
           [ngClass]="isDarkMode() ? (isSwap ? 'text-purple-400' : 'text-blue-400') : (isSwap ? 'text-purple-600' : 'text-blue-600')">
      {{ 'CURRENCY' | translate }}
    </label>
    <select
      [(ngModel)]="selectedCurrency"
      (change)="changeCurrency(selectedCurrency)"
      class="w-[90%] px-2 py-1 rounded-lg text-xs shadow-inner focus:outline-none transition border  focus:ring-0 focus:border-purple-500"
      [ngClass]="
        isDarkMode()
          ? 'bg-gray-800 text-white ' + (isSwap ? 'border-purple-700'
                                                : 'border-blue-700')
          : 'bg-white text-black ' + (isSwap ? 'border-purple-400'
                                            : 'border-blue-400')
      "
    >
      <option *ngFor="let currency of currencies" [value]="currency">{{ getCurrencyLabel(currency) }}</option>
    </select>
  </div>
</div>


    <!-- Bouton thème -->
    <a (click)="toggleTheme()" class="cursor-pointer flex items-center gap-2 px-2.5 py-1.5 mt-1.5 rounded-lg hover:bg-white/5 transition-all">
      <svg *ngIf="isDarkMode(); else lightIcon" class="w-4 h-4" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" stroke-width="1.25" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      <ng-template #lightIcon>
        <svg class="w-4 h-4" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" stroke-width="1.25" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      </ng-template>

      <span
        class="text-sm font-medium leading-tight"
        [ngClass]="
          isDarkMode()
            ? (isSwap ? 'text-purple-400' : 'text-blue-400')
            : (isSwap ? 'text-purple-600' : 'text-blue-600')
        "
      >
        {{ 'THEME' | translate }}
      </span>
    </a>
  </div>

  <!-- 🌐 Réseau (caché sur /disclaimer et /a-propos) -->
  <div class="w-full pb-3" *ngIf="isSwap && !isDisclaimer && !isAbout && !isBlog " [ngClass]="isDarkMode() ? 'border-white/10' : 'border-gray-300/70'">
    <label
      class="text-xs font-medium leading-tight"
      [ngClass]="
        isDarkMode()
          ? (isSwap ? 'text-purple-400' : 'text-blue-400')
          : (isSwap ? 'text-purple-600' : 'text-blue-600')
      "
    >
      {{ 'NETWORK' | translate }}
    </label>

    <ng-container *ngIf="isSwap; else placeholder">
      <div class="relative min-w-[150px] h-8 flex items-center">
        <button
          type="button"
          (click)="showNetworkDropdown = !showNetworkDropdown"
          class="flex items-center justify-between w-full px-2.5 py-1.5 h-8 rounded-xl text-sm font-medium border shadow-sm transition-all duration-200"
          [ngClass]="{
            'bg-white/80 text-gray-800 border-gray-300': !isDarkMode(),
            'bg-[#1e1e2f]/70 text-white border-gray-600': isDarkMode(),
            'hover:ring-2 hover:ring-purple-300': !isDarkMode() && isSwap,
            'hover:ring-2 hover:ring-blue-300': !isDarkMode() && !isSwap,
            'hover:ring-2 hover:ring-purple-500/40': isDarkMode() && isSwap,
            'hover:ring-2 hover:ring-blue-500/40': isDarkMode() && !isSwap
          }"
        >
          <div class="flex items-center gap-2">
            <img [src]="CHAIN_MAP[selectedNetwork].icon" class="w-4 h-4 rounded-full shadow-sm" />
            <span class="whitespace-nowrap leading-tight">{{ CHAIN_MAP[selectedNetwork].name }}</span>
          </div>
          <svg class="w-4 h-4 opacity-70" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
          </svg>
        </button>

        <!-- Dropdown réseaux -->
        <ul
          *ngIf="showNetworkDropdown"
          class="absolute top-full right-0 mt-1 w-full rounded-xl shadow-xl border z-30 overflow-hidden text-sm animate-fade-in"
          [ngClass]="{
            'bg-white border-gray-200 text-gray-800': !isDarkMode(),
            'bg-gray-900 border-gray-700 text-white': isDarkMode()
          }"
        >
          <li
            *ngFor="let id of [1, 137, 42161, 56]"
            (click)="selectNetwork(id); showNetworkDropdown = false"
            class="px-3 py-2 cursor-pointer flex items-center gap-2 transition font-medium"
            [ngClass]="
              isSwap
                ? 'hover:bg-purple-600 dark:hover:bg-purple-600'
                : 'hover:bg-blue-100 dark:hover:bg-blue-800'
            "
          >
            <img [src]="CHAIN_MAP[id].icon" class="w-4 h-4 rounded-full shadow-sm" />
            <span class="whitespace-nowrap leading-tight">{{ CHAIN_MAP[id].name }}</span>
          </li>
        </ul>
      </div>
    </ng-container>

    <!-- ✅ Placeholder si isSwap est false -->
    <ng-template #placeholder>
      <div class="min-w-[150px] h-8 flex items-center justify-between px-2.5 py-1.5 rounded-xl bg-gray-800/50 border border-gray-700 text-white/40 dark:text-gray-400">
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded-full bg-white/20 animate-pulse"></div>
          <span class="text-xs italic leading-tight">Chargement...</span>
        </div>
        <svg class="w-3.5 h-3.5 opacity-30" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </div>
    </ng-template>
  </div>
</div>
